"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Teach_exports = {};
__export(Teach_exports, {
  default: () => Teach_default
});
module.exports = __toCommonJS(Teach_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.33984 17.75C5.87109 17.75 5.47396 17.5872 5.14844 17.2617C4.82292 16.9362 4.66016 16.5456 4.66016 16.0898V4.41016C4.66016 3.95443 4.82292 3.5638 5.14844 3.23828C5.47396 2.91276 5.87109 2.75 6.33984 2.75H16.3398C16.5612 2.75 16.75 2.83464 16.9062 3.00391C17.0755 3.16016 17.1602 3.35547 17.1602 3.58984V16.9102C17.1602 17.1445 17.0755 17.3464 16.9062 17.5156C16.75 17.6719 16.5612 17.75 16.3398 17.75H6.33984ZM16.3398 16.9102V14.9961H6.33984C6.07943 14.9961 5.87109 15.0677 5.71484 15.2109C5.57161 15.3411 5.5 15.5885 5.5 15.9531C5.5 16.3177 5.58464 16.5716 5.75391 16.7148C5.92318 16.8451 6.11849 16.9102 6.33984 16.9102C6.40495 16.9102 6.66536 16.9102 7.12109 16.9102C7.57682 16.9102 8.22135 16.9102 9.05469 16.9102C9.88802 16.9102 10.9102 16.9102 12.1211 16.9102C13.332 16.9102 14.7383 16.9102 16.3398 16.9102ZM16.3398 3.58984H6.33984C6.11849 3.58984 5.92969 3.66146 5.77344 3.80469C5.61719 3.9349 5.52604 4.10417 5.5 4.3125V4.41016V13.9023C5.64323 13.7982 5.8125 13.7201 6.00781 13.668C6.21615 13.6159 6.44401 13.5898 6.69141 13.5898H16.3398V3.58984Z",
      fill: "currentColor"
    }
  )
);
const SvgTeach = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Teach_default = SvgTeach;
